'use client';

import { Box, VStack } from '@terra/ui-styled-system';
import { BodyStrong, MetaDefault, Spinner } from '@terra/ui-design-system';
import { useTranslations } from 'next-intl';

export function TorchAssetsDiscoveryWaiting() {
  const t = useTranslations('assetsTab');

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      h="full"
      w="full"
      p="6"
    >
      <VStack gap="4" alignItems="center" maxW="md">
        <Spinner size="md" />
        <VStack gap="2" alignItems="center">
          <BodyStrong color="fg.default" textAlign="center">
            {t('discoveryInProgress')}
          </BodyStrong>
          <MetaDefault color="fg.muted" textAlign="center">
            {t('discoveryInProgressDescription')}
          </MetaDefault>
        </VStack>
      </VStack>
    </Box>
  );
}
